export const scrollToPostId = (postId) => {
  const postToScroll = document.getElementById(`post-resp-${postId}`);
  if (postToScroll) {
    setTimeout(() => {
      window.scrollTo({
        behavior: 'smooth',
        top: postToScroll.offsetTop - 60,
      });
    }, 500);
  }
};



// WEBPACK FOOTER //
// ./src/utils/scroll.js